import { useContext } from "react";

import { AccountContext } from "../context/AccountContext";

export const useAccountHook = () => {
  const context = useContext(AccountContext);

  return context;
};
